import * as React from "react";

import { TextInput } from "src/components/forms";
import { Page, PageHero } from "src/components/common";
import { Button } from "src/components/buttons";
import { SectionMain } from "src/components/sections";
import Utils from "src/common/utils";
import { toast } from "react-toastify";

interface IState {
	password: string;
	passwordVerification: string;
	touched: {
		password: boolean;
		passwordVerification: boolean;
	};
}
class ResetPasswordPage extends React.Component<{}, IState> {
	private errors = {} as any;

	constructor(props: {}) {
		super(props);
		this.state = {
			password: "",
			passwordVerification: "",
			touched: {
				password: false,
				passwordVerification: false,
			},
		};
		this.onBlur = this.onBlur.bind(this);
		this.onChange = this.onChange.bind(this);
		this.submit = this.submit.bind(this);
	}

	public render() {
		this.errors = this.validate();
		return (
			<Page title="Reset Password">
				<PageHero className="page-header-empty" />
				<SectionMain sectionClassName="section-lg">
					<h2 className="text-secondary">Reset your password</h2>
					<div className="mt-4">
						<TextInput
							labelText="Password"
							type="password"
							name="password"
							onBlur={() => this.onBlur("password")}
							onChange={this.onChange}
							value={this.state.password}
							required={true}
							className="row col-md-8"
							error={
								Utils.shouldMarkError(
									this.errors.password,
									this.state.touched.password
								)
									? this.errors.password
									: undefined
							}
						/>
						<TextInput
							labelText="Re-enter your password"
							type="password"
							name="passwordVerification"
							onBlur={() => this.onBlur("passwordVerification")}
							onChange={this.onChange}
							value={this.state.passwordVerification}
							required={true}
							className="row col-md-8"
							error={
								Utils.shouldMarkError(
									this.errors.passwordVerification,
									this.state.touched.passwordVerification
								)
									? this.errors.passwordVerification
									: undefined
							}
						/>
						<Button
							className="btn-primary"
							onClick={this.submit}
							disabled={this.isSubmitDisabled()}
						>
							Submit
						</Button>
					</div>
				</SectionMain>
			</Page>
		);
	}

	private validate = () => {
		return {
			password: {
				hasError: this.state.password.length < 8,
				message: "Minimum 8 characters required.",
			},
			passwordVerification: {
				hasError: this.state.passwordVerification !== this.state.password,
				message: "Passwords do not match.",
			},
		};
	};

	private onBlur = (field: any) => {
		this.setState({
			touched: { ...this.state.touched, [field]: true },
		});
	};

	private onChange = (e: any) => {
		this.setState({ ...this.state, [e.target.name]: e.target.value });
	};

	private submit = () => {
		toast.info("Not yet implemented!");
	};

	private isSubmitDisabled = () => {
		const errors = this.validate();
		return errors.password.hasError || errors.passwordVerification.hasError;
	};
}

export default ResetPasswordPage;
